import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { Alert } from '../utils';
import { getAllOrdersAction } from '../Actions/orders';
import OrderDataTable from '../components/ClientPortal/orderTable';
import BackCmp from '../components/BackCmp';

const AllOrders = () => {
  const [activeTab, setActiveTab] = useState();
  const { activeSite, orders } = useSelector((state) => state);
  const navigate = useNavigate();

  useEffect(() => {
    if (activeSite || localStorage.getItem('portal-active-site-id')) {
      getAllOrdersAction(
        activeSite || localStorage.getItem('portal-active-site-id')
      );
    }
  }, [activeSite,  localStorage.getItem('portal-active-site-id')]);
  return (
    <div className="max-w-[1440px] w-full min-h-screen mx-auto pt-[82px] md:pt-[100px] px-4 md:px-10 mb-[40px] md:mb-[112px]">
      <div className="flex items-center mb-[29px]">
        <BackCmp />
        <Link
          to="/"
          className="font-medium text-[13px] leading-6 text-black hover:text-primary1 m-0 no-underline"
        >
          Home
        </Link>
        <div className=" w-[2px] h-3 bg-black mx-1" />
        <Link
          to="/collection"
          className=" no-underline  font-medium text-[13px] leading-6 text-black m-0"
        >
          Collection Kits
        </Link>
        <div className=" w-[2px] h-3 bg-black mx-1" />
        <h5 className="font-medium text-[13px] leading-6 text-primary1 m-0">
          Order History
        </h5>
      </div>
      <div className="w-full min-h-[100px] pt-[30px] px-[25px] pb-[20px] bg-white shadow-mdShadow">
        <Alert />
        {orders.allOrders ? (
          <div className="bg-white rounded-[5px] mb-[13px] inventory-tabs">
            <Tabs
              defaultActiveKey="All"
              id="uncontrolled-tab-example"
              className=""
              onSelect={(key) => {
                setActiveTab(key);
              }}
            >
              <Tab
                eventKey="All"
                title={<div className="flex items-center title-icon">All</div>}
              >
                <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">
                  Order History For This Site
                </h3>

                <OrderDataTable data={orders.allOrders || []} />
              </Tab>
              {!!orders.allOrders?.filter((status) => status.status.id === 1)
                ?.length && (
                <Tab
                  eventKey="Recieved"
                  title={
                    <div className="flex items-center title-icon">Recieved</div>
                  }
                >
                  <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">
                    Order History For This Site
                  </h3>

                  <OrderDataTable
                    data={
                      orders.allOrders?.filter(
                        (status) => status.status.id === 1
                      ) || []
                    }
                  />
                </Tab>
              )}
              {!!orders.allOrders?.filter((status) => status.status.id === 2)
                ?.length && (
                <Tab
                  eventKey="In Process"
                  title={
                    <div className="flex items-center title-icon">
                      In Process
                    </div>
                  }
                >
                  <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">
                    Order History For This Site
                  </h3>

                  <OrderDataTable
                    data={
                      orders.allOrders?.filter(
                        (status) => status.status.id === 2
                      ) || []
                    }
                  />
                </Tab>
              )}
              {!!orders.allOrders?.filter((status) => status.status.id === 3)
                ?.length && (
                <Tab
                  eventKey="Shipped"
                  title={
                    <div className="flex items-center title-icon">Shipped</div>
                  }
                >
                  <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">
                    Order History For This Site
                  </h3>

                  <OrderDataTable
                    data={
                      orders.allOrders?.filter(
                        (status) => status.status.id === 3
                      ) || []
                    }
                  />
                </Tab>
              )}
              {!!orders.allOrders?.filter((status) => status.status.id === 4)
                ?.length && (
                <Tab
                  eventKey="Delivered"
                  title={
                    <div className="flex items-center title-icon">
                      Delivered
                    </div>
                  }
                >
                  <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">
                    Order History
                  </h3>

                  <OrderDataTable
                    data={
                      orders.allOrders?.filter(
                        (status) => status.status.id === 4
                      ) || []
                    }
                  />
                </Tab>
              )}
            </Tabs>
          </div>
        ) : (
          <div>
            <Skeleton count="5" />
            <br />
            <Skeleton count="5" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AllOrders;
